import { zodResolver } from '@hookform/resolvers/zod'
import {
  type CreatePortfolioSchema,
  createPortfolioSchema,
} from '@labi-api-libs/schemas'
import { Plus } from 'lucide-react'
import { useForm } from 'react-hook-form'
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Textarea,
} from '@/components/ui'

export function DialogCreatePortfolio({
  isOpen,
  onOpenChange,
  handleSubmit,
  isLoading,
}: {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  handleSubmit: (data: CreatePortfolioSchema) => void
  isLoading: boolean
}) {
  const form = useForm<CreatePortfolioSchema>({
    resolver: zodResolver(createPortfolioSchema),
    defaultValues: {
      title: '',
      description: '',
    },
  })

  const onSubmit = (data: CreatePortfolioSchema) => {
    handleSubmit(data)
    form.reset()
    onOpenChange(false)
  }

  const onClose = () => {
    form.reset()
    onOpenChange(!isOpen)
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogTrigger asChild>
        <Plus className="size-4 text-system-text-secondary hover:text-system-text-primary" />
      </DialogTrigger>

      <DialogContent>
        <DialogHeader>
          <DialogTitle>Criar novo portfólio</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          Crie um portfólio para reunir projetos
        </DialogDescription>

        <Form {...form}>
          <form
            id="create-portfolio-form"
            className="flex flex-col gap-6"
            onSubmit={form.handleSubmit(onSubmit)}
          >
            <FormField
              control={form.control}
              name="title"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Nome do portfólio</FormLabel>
                  <FormControl>
                    <Input
                      placeholder="Digite o nome do portfólio"
                      value={field.value}
                      onChange={field.onChange}
                      variant={form?.formState?.errors?.title && 'error'}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="description"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Descrição</FormLabel>
                  <FormControl>
                    <Textarea
                      placeholder="Descrição do portfólio"
                      value={field.value}
                      onChange={field.onChange}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </form>
        </Form>

        <DialogFooter>
          <div className="flex items-center gap-2">
            <Button
              type="submit"
              disabled={isLoading}
              variant="slate"
              form="create-portfolio-form"
            >
              Criar portfólio
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
